import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';

import {
  FilesizePipe,
  PrimengButtonDirective,
  UploadDropzoneBorderComponent,
} from '@web/shared/ui';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-multimedia-choose-or-upload-dropzone',
  imports: [
    FilesizePipe,
    UploadDropzoneBorderComponent,
    Button,
    PrimengButtonDirective,
  ],
  templateUrl: './multimedia-choose-or-upload-dropzone.component.html',
  styleUrl: './multimedia-choose-or-upload-dropzone.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultimediaChooseOrUploadDropzoneComponent {
  public readonly disabled = input(false);
  public readonly maxFileSize = input.required<number>();
  public readonly sendFileClickEvent = output();
  public readonly multimediaLibraryClickEvent = output();

  public handleSendFileClick(): void {
    this.sendFileClickEvent.emit();
  }

  public handleMultimediaLibraryClick(): void {
    this.multimediaLibraryClickEvent.emit();
  }
}
